<template>
  <div class="div">
    <el-form
      ref="form"
      :rules="rules"
      :model="model"
      label-width="80px"
      label-position="right"
    >
      <el-form-item
        label="Periodo"
        prop="periodId"
      >
        <el-select
          v-model="model.periodId"
          filterable
          remote
          placeholder="Escriba el periodo"
          :remote-method="onLoadPeriod"
          :loading="isLoadingPeriods"
        >
          <el-option
            v-for="item in periods"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          />
        </el-select>
      </el-form-item>

      <el-form-item
        label="Layout"
        prop="layoutId"
      >
        <el-select
          v-model="model.layoutId"
          filterable
          remote
          placeholder="Escriba el layout"
          :remote-method="onLoadLayouts"
          :loading="isLoadingLayouts"
        >
          <el-option
            v-for="item in layouts"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          />
        </el-select>
      </el-form-item>

      <el-form-item label="Rango">
        <el-date-picker
          v-model="dateRange"
          :picker-options="pickerOptions"
          type="daterange"
          range-separator="-"
          start-placeholder="Inicio"
          end-placeholder="Fin"
          @change="updateDates"
        />
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import Layout from './assignments.model'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'AssignmentsForm',
  data () {
    return {
      model: Layout.model(),
      dateRange: [],
      isLoadingPeriods: false,
      isLoadingLayouts: false,
      rules: Layout.validations,
      pickerOptions: {
        disabledDate: time => {
          let currentDate = new Date(time)
          let startDate = new Date(this.currentPeriod.startDate)
          let endDate = new Date(this.currentPeriod.endDate)
          return !(startDate <= currentDate && endDate >= currentDate)
        }
      }
    }
  },
  computed: {
    currentPeriod () {
      return this.periods.find(element => {
        return element.id === this.model.periodId
      })
    },
    ...mapGetters('periods', {
      periods: 'items'
    }),
    ...mapGetters('layouts', {
      layouts: 'items'
    })
  },
  beforeCreate () {
    console.log('before create')
    this.$store.dispatch('periods/query')
    this.$store.dispatch('layouts/query')
  },
  methods: {
    ...mapActions('assignments', ['save', 'query']),
    ...mapActions('periods', { queryPeriods: 'query' }),
    ...mapActions('layouts', { queryLayouts: 'query' }),
    isDateDisabled (date) {
      return false
    },
    onLoadPeriod (search) {
      this.isLoadingPeriods = true
      this.queryPeriods({
        'filters[where][name][contains]': search,
        select: 'id,name'
      }).finally(() => {
        this.isLoadingPeriods = false
      })
    },
    onLoadLayouts (search) {
      this.isLoadingLayouts = true
      this.queryLayouts({
        'filters[where][name][contains]': search,
        select: 'id,name'
      }).finally(() => {
        this.isLoadingLayouts = false
      })
    },
    onSubmit () {
      this.$refs['form'].validate(valid => {
        if (valid) {
          this.save(this.model)
            .then(response => {
              this.query().then(() => {
                this.$router.push({ name: 'assignments' })
              })
            })
            .catch(error => {
              console.log(error)
              return Promise.reject(error)
            })
        } else {
          this.$notify({
            group: 'app',
            title: 'Verifica la forma.',
            text:
              'Por favor, revisa lo errores que se indican dentro de la forma.'
          })
          return false
        }
      })
    },
    updateDates () {
      this.model.startDate = this.dateRange[0]
      this.model.endDate = this.dateRange[1]
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/modules/assignments/assignments-form.vue